// React Imports
import React, { Component } from "react"

// Package Imports
import Modal from "react-bootstrap/Modal"
import isObjectEmpty from "utils/isObjectEmpty"
import { observer } from "mobx-react"
import * as APITypes from "../../../constants/API"
import axios from "../../../utils/axios"
import { toJS } from "mobx"


// Project Immports
import BottomsheetDropdown from "../bottomsheet-dropdown/BottomsheetDropdown"
import MaturityPayOutModalForm from "./maturityForm"
import maturityPayOutModeFormController from "./maturityForm/controller"
import AuthStore from "modules/login/store/AuthStore"
import OptimizationStore from "modules/optimization/store/OptimizationStore"
import OptimizationStoreOld from "modules/optimization-old/store/OptimizationStore"

import onChangeMaturityPayoutMode from "modules/optimization/utils/maturity-payout-mode/changeMaturityPayoutMode"

// css imports
import "./Maturity-pay-out-modal.css"
import getCookie from "utils/journeyIdCookie/getJourneyId"
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "../../../constants/Constants"
import StorageKeys from "constants/StorageKeys"
class MaturityPayOutModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      formController: undefined,
      store: OptimizationStoreOld
    }
    this.maturityPayOutModeOnChange = this.maturityPayOutModeOnChange.bind(this)
  }
  
  async componentDidMount() {
    let currentLocation = window.location.pathname
    if (!currentLocation.includes("customization-old"))  {
      this.setState({store : OptimizationStore}) 
    } 

    let controller = new maturityPayOutModeFormController()
    let journeyData = toJS(AuthStore.journeyData)
    let journeyId = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID)

    controller.setDefaults(journeyData, journeyId, this.props.cardkey, this.props.data)

    this.setState({ formController: controller })
  }

  submitData = () => {
    this.state.formController
      .validate({ showErrors: true })
      .then(({ isValid }) => {
        if (isValid) {
          this.changeTargetAmount().then(()=>{
            this.closeModal()
          console.log("maturity payout mode submitted")
          })
        } else {
          console.log("Form errors are ", this.state.formController.errors())
        }
      })
  }

  async changeTargetAmount(data) {
    let currentLocation = window.location.pathname
    const { store } = this.state

    try {

      let formData = this.state.formController.$("target_amount_dropdown").value;

      let selectProduct = this.state.formController.$("products_list").value;
      let risk = this.props.data.selectedRisk ? this.props.data.selectedRisk : "low"
      let productListData = toJS(store.product_list_data);
      let familyProductID="";
      for(let i=0; i<productListData.length; i++){
        let obj = productListData[i];
        if(obj.data.length>0){
          for (let j=0;j<obj.data.length; j++){
            let dataObj = obj.data[j];
            familyProductID = dataObj?.BI[0]?.family_product_id;
          }
        }
      }
      let data = {
        "user_journey_id": getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
        "family_member_id": this.props.familyMemberId,
        "need_id": formData.need_id_id,
        "existing_payout_mode" : formData.mode =="INCOME"?"lumpsum":"income",
        "new_payout_mode" : formData.mode =="INCOME"?"income":"lumpsum",
        "target_amount_id": formData.id,
        "family_product_id": this.props.data.BI[0]?.family_product_id,
        "priority": risk,
        "selected_product_package_id":selectProduct?.package_id ? selectProduct?.package_id  : null,
        "selected_product_risk":selectProduct?.risk ? selectProduct?.risk  : null
        }
      
      store.onChangeMaturityPayoutMode(false)
      if (!currentLocation.includes("customization-old"))  {
        onChangeMaturityPayoutMode(data)
      } else {
        global.loading(true);
        var response = await axios.post(APITypes.CHANGE_TARGET_AMOUNT, data);
        if (response.data.status == "error") {
          return false;
        } else {
  
          // let responseDataArr = response.data;
          let responseDataArr = store.formatProductResponseData(response);
  
          productListData.forEach((item) => {
            if (responseDataArr[0].need_unique_name === item.need_unique_name) {
              item.data.map((productData) => {
                if(Array.isArray(productData.BI) && productData.BI[0]?.family_product_id === responseDataArr[0].data[0].BI[0]?.family_product_id){
                  productData.BI = responseDataArr[0].data[0].BI
                  productData.payout_mode = responseDataArr[0].data[0].payout_mode
                }
              });
            }
          })
          store.product_list_data = [...productListData];
          return true;
        }
      }
    } catch (error) {
      return false;
    } finally {
      if (!currentLocation.includes("customization-old"))  {
        global.loading(false);
      }
    }
  }

  maturityPayOutModeOnChange(selectedObj) {
    const { store } = this.state

    store.onChangeMaturityPayoutMode(true)
    this.state.formController.$("target_amount_type").value = selectedObj
    this.props.showBackDropFunction()
  }

  closeModal = () => {
    this.props.hideBackDropFunction()
  }

  checkEnability = () => {
    let currentLocation = window.location.pathname
    let fieldDisabled = false
    if (!currentLocation.includes("customization-old"))  {
      fieldDisabled = this.props.data.BI.some((item)=> !item.update_BI)
    }
  }

  render() {
    if (this.state.formController === undefined) return null

    const { formController } = this.state


    return (
      <div className="maturityPayOutMode">
        <div className="row">
          <div className="col">
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey="label"
              bottomsheetTitle="Maturity Payout Mode"
              menuList={formController.$("target_amount_type").extra.optionList}
              value={formController.$("target_amount_type").value}
              onSelect={(selectedObj) =>
                this.maturityPayOutModeOnChange(selectedObj)
              }
              showErrorMsg={false}
              errorMsg={""}
              disabled={this.checkEnability()}
            />
          </div>
        </div>

        {this.props.showModalBackDrop && (
          <MaturityPayOutModalForm
            formController={formController}
            targetAmountType={
              formController?.$("target_amount_type")?.value?.label
            }
            closeModal={this.closeModal}
            submitData={this.submitData}
          />
        )}
      </div>
    )
  }
}

export default observer(MaturityPayOutModal)
